import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import ListFormFonts from './ListFormFont'
import ListFormStyle from './ListFormStyle'
import type { ListFormBrandType, ListBrandForms } from './listTypes'

const FORM_MAP: ListBrandForms = {
  [BrandFormEnum.STYLE]: ListFormStyle,
  ...(ListFormFonts as ListBrandForms),
}

const ListFormBrand: ListFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(ListFormBrand) as typeof ListFormBrand
